import styled from "styled-components";

export const StyledTriggerLink = styled.a`
  font-weight: normal;
  font-style: italic;
`;
